import { getLangCode } from "./globals.js";
import { ES } from "./es.js";
import { EN } from "./en.js";
import { FR } from "./fr.js";
import { DE } from "./de.js";
import { IT } from "./it.js";
import { RU } from "./ru.js";

const LANGS = {
  es: ES,
  en: EN,
  fr: FR,
  de: DE,
  it: IT,
  ru: RU
};

export function getReportLang() {
  const code = getLangCode();
  return LANGS[code] || EN;
}



